/* Desarrollo */
/* const baseURL = "http://localhost/Catalogo_agropartes/public";
export default baseURL; */

/* Producción */
const baseURL = "https://tienda.agropartesdongoyo.com";
export default baseURL; 